import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';

import { GridColumns } from '../slider.types';

/**
 * @slot - contents to display in slider item
 */
@Component({
  tag: 'wb-slider-item',
  styleUrl: './slider-item.scss',
  shadow: true,
})
export class SliderItemComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /** width on mq1 in grid columns */
  @Prop({ reflect: true, attribute: 'mq1' })
  public mq1?: GridColumns;

  /** width on mq2 in grid columns */
  @Prop({ reflect: true, attribute: 'mq2' })
  public mq2?: GridColumns;

  /** width on mq3 in grid columns */
  @Prop({ reflect: true, attribute: 'mq3' })
  public mq3?: GridColumns;

  /** width on mq4 in grid columns */
  @Prop({ reflect: true, attribute: 'mq4' })
  public mq4?: GridColumns;

  /** width on mq5 in grid columns */
  @Prop({ reflect: true, attribute: 'mq5' })
  public mq5?: GridColumns;

  /** width on mq6 in grid columns */
  @Prop({ reflect: true, attribute: 'mq6' })
  public mq6?: GridColumns;

  public render(): JSX.Element {
    return (
      <Host class="wb-slider-item">
        <slot />
      </Host>
    );
  }
}
